import { render } from "./icons-facebook.svg?vue&type=template&id=d6b57046?inline"
const script = {}
script.render = render

export default script